<template>
  <div>
    <div class="pay">
      <div class="pay-header">
        <span>
          My Account:
          <em>{{ account }}</em>
        </span>
        <span>
          Balance:
          <em>RM{{ balance }}</em>
        </span>
        <a class="fr" @click="linkCardStockPay">
          go to Wallet Topup
          <i class="iconfont iconyoujiantou"></i>
        </a>
      </div>
      <el-row class="container1">
        <el-col :span="9">
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            :rules="rules"
            class="ruleForm"
          >
            <el-form-item class="item">
              <p><i class="iconfont iconzhanghao"></i>Coupon Number</p>
              <el-input
                v-model="ruleForm.cardKey"
                placeholder="Please input Card Secret"
              ></el-input>
            </el-form-item>
            <el-form-item class="item">
              <p><i class="iconfont iconmima"></i>CAPTCHA</p>
              <el-input
                v-model="ruleForm.imageCode"
                placeholder="Enter captcha code here"
              ></el-input>
              <div class="fixed-right" @click="refreshCode">
                <s-identify :identifyCode="identifyCode"></s-identify>
              </div>
            </el-form-item>
            <el-button type="primary" @click="goPay('ruleForm')"
              >Reload</el-button
            >
          </el-form>
        </el-col>
        <el-col :span="13" :offset="2">
          <ul class="list">
            <li
              class="item"
              v-for="(item, index) in cardList"
              :key="index"
              @click="goCard(item.url)"
            >
              <img :src="item.img" alt />
            </li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <el-row class="container2">
      <h2 class="title">About Coupon</h2>
      <p>
        After you get the coupon number, please enter the coupon number in the
        text box and click ‘Reload’ button. After the balance is used up, you
        can reload again by purchase coupon.
        <em>The reload coupons are not refundable.</em>
      </p>
      <p>
        Multiple coupons can be used together or stacked for the same order. If
        you reload with multiple coupons, GetStock.cc website will keep update
        you about your remaining account
        <em>balance.</em>
      </p>
      <p>
        In order to avoid fraudulent activities such as malicious order, refund
        and etc., (such as give bad review intentionally without any reason),
        all users whom request for refund will be automatically blacklisted and
        they will never be allowed to place an order in Getstock.cc.
      </p>
    </el-row>
    <el-row class="container3">
      <el-table :data="tableData">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column label="Order ID" prop="paySerial"></el-table-column>
        <el-table-column
          label="Payment Method"
          :formatter="payFormat"
        ></el-table-column>
        <el-table-column
          label="Reload Amount"
          prop="payAmount"
        ></el-table-column>
        <el-table-column label="Reload Time" prop="payTime"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize"
        v-if="totalSize > 10"
      ></el-pagination>
    </el-row>
    <DialogList
      :dialogVisible="dialogTableVisibleNew"
      @closeDialog="closeConstDetailPop"
    />
    <Accountdialog
      :dialogVisible="accountDialogTableVisible"
      @closeDialog="closeAccountDetailPop"
    />
  </div>
</template>

<script>
import { doCharge } from "@/api/charge";
import { getChargeList } from "@/api/order";
import { message } from "@/utils/resetMessage";
import SIdentify from "@/components/identify/identify";
import { getSessionUser } from "@/api/auth";
import DialogList from "../materialDownload/module/dialog.vue";
import Accountdialog from "../materialDownload/module/accountdialog";

// 支付方式映射
const PAY_WAY_MAP = new Map([
  [1, "Card"],
  [3, "WX"],
  [6, "BTC"],
]);

export default {
  components: {
    SIdentify,
    DialogList,
    Accountdialog,
  },
  data() {
    return {
      ruleForm: {
        cardKey: "",
        imageCode: "",
      },
      account: "",
      balance: "",
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      cardList: [],
      rules: {
        cardKey: [
          {
            required: true,
            message: "Paste your coupon number here",
            trigger: "blur",
          },
        ],
        imageCode: [
          {
            required: true,
            message: "Enter captcha code here",
            trigger: "blur",
          },
        ],
      },
      identifyCodes: "1234567890",
      identifyCode: "",
      dialogTableVisibleNew: false,
      accountDialogTableVisible: false,
    };
  },
  computed: {
    isLoggedIn() {
      const { token, loginNameType } = this.$store.state.user;
      return Boolean(token && loginNameType != null);
    },
  },
  mounted() {
    this.$EventBus.$on("constDetailOut", this.openConstDetailPop);
    this.$EventBus.$on("accountDetailOut", this.openAccountDetailPop);
    this.getUserList();
    this.refreshCode();
    this.getCardList();
    this.getTableData();
  },
  beforeDestroy() {
    this.$EventBus.$off("constDetailOut", this.openConstDetailPop);
    this.$EventBus.$off("accountDetailOut", this.openAccountDetailPop);
  },
  methods: {
    payFormat(row) {
      return PAY_WAY_MAP.get(row.payWay) || "Alipay";
    },

    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },

    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },

    makeCode(chars, length) {
      for (let i = 0; i < length; i++) {
        this.identifyCode += chars[this.randomNum(0, chars.length)];
      }
    },

    async getUserList() {
      try {
        const result = await getSessionUser({});
        this.$store.dispatch("setUserInfo", result);
        if (this.$store.state.user.loginNameType) {
          this.account =
            this.$store.state.user.loginNameType === 1
              ? this.$store.state.common.userInfo.mobile
              : this.$store.state.common.userInfo.mail;
          this.balance = this.$store.state.common.userInfo.blance;
        }
      } catch (error) {
        console.error("Get user error:", error);
      }
    },

    getCardList() {
      this.cardList = [
        { img: "", url: "" },
        { img: "", url: "" },
        { img: "", url: "" },
      ];
    },

    async getTableData() {
      const dataform = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        type: 1,
      };
      try {
        const result = await getChargeList(dataform);
        this.tableData = result.list;
        this.totalSize = result.count;
      } catch (error) {
        console.error("Get charge list error:", error);
      }
    },

    goPay(formName) {
      if (!this.isLoggedIn) {
        message.error({
          message: "Please Log In",
          duration: 4000,
          offset: 80,
        });
        return;
      }

      this.$refs[formName].validate((valid) => {
        if (!valid) return;

        if (this.ruleForm.imageCode !== this.identifyCode) {
          message.error({
            message: "The verification code is incorrect. Please re-enter.",
            duration: 4000,
            offset: 80,
          });
          this.refreshCode();
          return;
        }

        doCharge(this.ruleForm)
          .then((result) => {
            message.success({
              message: "Reload Success.",
              duration: 4000,
              offset: 80,
            });
            this.$store.dispatch("setUserInfo", result);
            this.ruleForm = { cardKey: "", imageCode: "" };
            this.getUserList();
            this.getTableData();
          })
          .catch(() => {
            message.error({
              message: "Reload error, please try again.",
              duration: 4000,
              offset: 80,
            });
            this.refreshCode();
          });
      });
    },

    goCard(url) {
      window.open(url, "_blank");
    },

    linkCardStockPay() {
      this.$router.push({ path: "/pay" });
      this.$store.commit("asideMenuId", 2);
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getTableData();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },

    openConstDetailPop() {
      this.dialogTableVisibleNew = true;
    },

    closeConstDetailPop() {
      this.dialogTableVisibleNew = false;
    },

    openAccountDetailPop() {
      this.accountDialogTableVisible = true;
    },

    closeAccountDetailPop() {
      this.accountDialogTableVisible = false;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.pay {
  padding: 25px 40px 40px;
  margin-bottom: 20px;
  background: #fff;
  .pay-header {
    padding-bottom: 15px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
    span {
      color: #767676;
      em {
        color: #000;
        font-size: 16px;
      }
      &:nth-child(2) {
        margin-left: 15px;
      }
    }
    .fr {
      float: right;
      font-size: 14px;
      color: #909090;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
.container1 {
  .item {
    margin-bottom: 20px;
    position: relative;
    p {
      display: block;
      font-size: 14px;
      color: #000;
      .iconfont {
        margin-right: 10px;
        font-size: 16px;
      }
    }
    .input {
      width: 100%;
      height: 40px;
      border: none;
      border-bottom: 1px solid #767676;
    }

    .inputCode {
      width: 80%;
    }

    .fixed-right {
      margin-top: 5px;
      flex: 0 0 200px; /* 右侧固定宽度 */
      margin-left: auto; /* 将右侧内容推到最右边 */
    }

    .codeImg {
      position: absolute;
      right: 0;
      bottom: 15px;
      width: 160px;
      height: 50px;
      border: 1px solid #e5e5e5;
    }
  }
  .el-button {
    margin-top: 40px !important;
    padding: 12px 25px;
    height: 44px !important;
  }
  .list {
    li {
      margin-bottom: 10px;
      float: left;
      width: 240px;
      cursor: pointer;
      img {
        width: 90%;
      }
    }
  }
}
.container2 {
  margin-bottom: 20px;
  background: #fff;
  border: 1px solid #feaf06;
  padding: 5px 35px 15px;
  .title {
    margin-bottom: 16px;
    line-height: 50px;
    font-size: 16px;
    color: #1f1f1f;
    border-bottom: 1px solid #e8e8e8;
  }
  p {
    margin-bottom: 15px;
    line-height: 20px;
    color: #898989;
  }
}
.container3 {
  margin-bottom: 60px;
}
</style>
